import { SectionCard } from "./SectionCard";
import { FooterText } from "./FooterText";

const SavingsTermsAndConditions = () => {
  return (
    <div className="container my-4 px-3" style={{ textAlign: "justify" }}>
      <header className="pb-3 mb-4 text-center">
        <h2 className="card-title text-primary fw-bolder">
          TERMS AND CONDITIONS – KEGOW SAVINGS PRODUCT
        </h2>
        <p className="text-muted mt-2">
          Please read the Terms and Conditions below carefully before using the
          Kegow Savings feature. If you do not accept these Terms, do not
          proceed.
        </p>
      </header>
      <div>
        <SectionCard
          title="1. Definitions"
          customContent={
            <ul className="list-unstyled mb-0">
              <li className="mb-2">
                1.1 <strong>"Kegow"</strong> refers to the Kegow Wallet
                platform.
              </li>
              <li className="mb-2">
                1.2 <strong>"Savings"</strong> refers to the interest-bearing
                savings feature linked to a user's Kegow Wallet.
              </li>
              <li className="mb-2">
                1.3 <strong>"Wallet"</strong> refers to the user's primary
                transaction account on Kegow.
              </li>
              <li className="mb-2">
                1.4 <strong>"Daily Closing Balance"</strong> means the final
                balance in the Savings account at the end of each day.
              </li>
              <li className="mb-2">
                1.5 <strong>"Average Daily Balance (ADB)"</strong> means the
                average of all Daily Closing Balances within a given period.
              </li>
              <li className="mb-2">
                1.6 <strong>"Accrued Interest"</strong> means interest
                calculated daily but not yet credited.
              </li>
            </ul>
          }
        />

        <SectionCard
          title="2. Acceptance of Terms"
          customContent={
            <p>
              By accessing or using the Kegow Savings feature, you agree to be
              bound by these Terms and Conditions.
            </p>
          }
        />

        <SectionCard
          title="3. Eligibility"
          customContent={
            <>
              <p>To use Kegow Savings, you must:</p>
              <ul className="ms-4">
                <li>Have a valid and verified Kegow Wallet account;</li>
                <li>Meet all KYC requirements as determined by Kegow;</li>
                <li>Comply with all applicable laws and regulations.</li>
              </ul>
            </>
          }
        />

        <SectionCard
          title="4. Product Description"
          customContent={
            <>
              <p>
                Kegow Savings is an interest-bearing savings feature that allows
                users to earn returns on available balances while retaining full
                access to funds.
              </p>
              <p className="mt-2">
                Savings accounts are automatically created for all users upon
                wallet creation.
              </p>
            </>
          }
        />

        <SectionCard
          title="5. Interest Structure"
          customContent={
            <>
              <p className="fw-bold mb-2">5.1 Interest Rate</p>
              <ul className="ms-4 mb-3">
                <li>
                  Interest is calculated at an annual rate determined by Kegow
                  (currently up to 6% per annum).
                </li>
                <li>
                  Kegow reserves the right to modify the interest rate at any
                  time.
                </li>
              </ul>

              <p className="fw-bold mb-2">5.2 Interest Calculation</p>
              <ul className="ms-4 mb-3">
                <li>
                  Interest is calculated daily using the Daily Closing Balance.
                </li>
                <li>
                  Monthly interest is based on the Average Daily Balance (ADB).
                </li>
              </ul>

              <p className="fw-bold mb-2">5.3 Interest Accrual and Payment</p>
              <ul className="ms-4 mb-3">
                <li>
                  Interest accrues daily but is not immediately available for
                  withdrawal.
                </li>
                <li>
                  Accrued interest is credited monthly into the user's Savings
                  or Wallet.
                </li>
              </ul>

              <p className="fw-bold mb-2">5.4 Interest Eligibility</p>
              <p>Interest accrual is subject to:</p>
              <ul className="ms-4 mb-2">
                <li>Minimum balance requirements;</li>
                <li>A minimum holding period (e.g., 24 hours);</li>
                <li>Minimum active days within a cycle;</li>
              </ul>
              <p>
                Kegow reserves the right to withhold or reverse interest where
                eligibility criteria are not met.
              </p>
            </>
          }
        />

        <SectionCard
          title="6. Deposits and Withdrawals"
          customContent={
            <>
              <p className="fw-bold mb-2">6.1 Manual Transfers</p>
              <p className="mb-3">
                Users may transfer funds between Wallet and Savings at any time.
              </p>

              <p className="fw-bold mb-2">6.2 Withdrawals</p>
              <ul className="ms-4">
                <li>
                  Users may withdraw funds from Savings at any time without
                  restriction.
                </li>
                <li>Withdrawals may impact interest eligibility.</li>
              </ul>
            </>
          }
        />

        <SectionCard
          title="7. Transaction Processing"
          customContent={
            <>
              <ul className="ms-4 mb-3">
                <li>
                  All transactions are processed in real time, subject to system
                  availability.
                </li>
                <li>
                  Kegow uses automated systems to execute transfers between
                  Wallet and Savings.
                </li>
                <li>
                  In case of failure, transactions may be reversed or retried.
                </li>
              </ul>
              <p className="fw-bold">Kegow reserves the right to:</p>
              <ul className="ms-4">
                <li>Suspend or cancel interest accrual;</li>
                <li>Impose withdrawal limits;</li>
                <li>Freeze accounts for investigation;</li>
                <li>Reverse improperly earned interest.</li>
              </ul>
            </>
          }
        />

        <SectionCard
          title="8. Taxation"
          customContent={
            <>
              <ul className="ms-4">
                <li>
                  Interest earned may be subject to applicable taxes, including
                  withholding tax, in accordance with Nigerian law.
                </li>
                <li>Kegow may deduct such taxes before crediting interest.</li>
              </ul>
            </>
          }
        />

        <SectionCard
          title="9. Risks and Disclaimers"
          customContent={
            <>
              <ul className="ms-4">
                <li>Interest rates are not guaranteed and may change.</li>
                <li>
                  Service availability may be affected by technical or
                  operational issues.
                </li>
                <li>
                  Kegow does not guarantee uninterrupted access to the Savings
                  feature.
                </li>
              </ul>
            </>
          }
        />

        <SectionCard
          title="10. Limitation of Liability"
          customContent={
            <>
              <p>Kegow shall not be liable for:</p>
              <ul className="ms-4">
                <li>Losses arising from system downtime or delays;</li>
                <li>Losses resulting from user actions or negligence;</li>
                <li>Indirect or consequential damages.</li>
              </ul>
            </>
          }
        />

        <SectionCard
          title="11. Suspension and Termination"
          customContent={
            <>
              <p>Kegow may suspend or terminate access to Savings where:</p>
              <ul className="ms-4">
                <li>There is a breach of these Terms;</li>
                <li>Fraud or suspicious activity is detected;</li>
                <li>Required by law or regulatory authorities.</li>
              </ul>
            </>
          }
        />

        <SectionCard
          title="12. Amendments"
          customContent={
            <p>
              Kegow reserves the right to amend these Terms at any time.
              Continued use constitutes acceptance of the updated Terms.
            </p>
          }
        />

        <SectionCard
          title="13. Governing Law"
          customContent={
            <p>
              These Terms shall be governed by the laws of the Federal Republic
              of Nigeria.
            </p>
          }
        />

        <SectionCard
          title="14. Support"
          customContent={
            <div className="d-flex flex-column flex-sm-row gap-4">
              <div>
                <strong> Phone:</strong>{" "}
                <a href="tel:08079664791" className="text-decoration-none">
                  08079664791
                </a>
              </div>
              <div>
                <strong> Email:</strong>{" "}
                <a
                  href="mailto:support@kegow.com"
                  className="text-decoration-none"
                >
                  support@kegow.com
                </a>
              </div>
            </div>
          }
        />

        <FooterText
          supportText="For inquiries or customer support regarding the Kegow Savings product, please contact Kegow customer service through the official app channels or via the support details above."
          lastUpdated="April 10, 2026."
          termsText="Kegow Savings Product Terms and Conditions."
        />
      </div>
    </div>
  );
};

export default SavingsTermsAndConditions;
